import { render, staticRenderFns } from "./PdfTreeItem.vue?vue&type=template&id=28777e90&scoped=true&"
import script from "./PdfTreeItem.vue?vue&type=script&lang=js&"
export * from "./PdfTreeItem.vue?vue&type=script&lang=js&"
import style0 from "./PdfTreeItem.vue?vue&type=style&index=0&id=28777e90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28777e90",
  null
  
)

export default component.exports